import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { useState } from "react";
import { isAdministrator } from "../../utils/userRoleUtils";
import AdminSettings from "./adminSettings";
import AppLogManagement from "./appLogManagement";
import ChatConversationManagement from "./chatConversationManagement";
import CommercialFindingManagement from "./commercialFindingManagement";
import CustomerManagement from "./customerManagement";
import KnowledgeInsightManagement from "./knowledgeInsightManagement";
import PriceObservationManagement from "./priceObservationManagement";
import ProductManagement from "./productManagement";
import PromotionEventManagement from "./promotionEventManagement";
import RawSaleRecordManagement from "./rawSaleRecordManagement";
import UserManagement from "./userManagement";
import WorkerLogManagement from "./workerLogManagement";
import AdminTabContent from "./adminTabContent";
import UsageRecordManagement from "./usageRecordManagement";

const Admin: React.FC = () => {
    const [selectedTab, setSelectedTab] = useState(0);
    const userIsAdministrator = isAdministrator();
    if (!userIsAdministrator) {
        return <></>;
    }

    return (
        <div className="h-100 min-h-0 overflow-hidden">
            <TabStrip
                className="admin-tabstrip"
                selected={selectedTab}
                tabPosition="left"
                onSelect={event => setSelectedTab(event.selected)}
            >
                <TabStripTab title="Logs">
                    <AdminTabContent>
                        <AppLogManagement />
                    </AdminTabContent>
                </TabStripTab>

                <TabStripTab title="Worker Logs">
                    <AdminTabContent>
                        <WorkerLogManagement />
                    </AdminTabContent>
                </TabStripTab>

                <TabStripTab title="Usage">
                    <AdminTabContent>
                        <UsageRecordManagement />
                    </AdminTabContent>
                </TabStripTab>

                <TabStripTab title="Conversations">
                    <AdminTabContent>
                        <ChatConversationManagement />
                    </AdminTabContent>
                </TabStripTab>

                <TabStripTab title="Products">
                    <AdminTabContent>
                        <ProductManagement />
                    </AdminTabContent>
                </TabStripTab>

                <TabStripTab title="Raw Sales">
                    <AdminTabContent>
                        <RawSaleRecordManagement />
                    </AdminTabContent>
                </TabStripTab>

                <TabStripTab title="Promotion Events">
                    <AdminTabContent>
                        <PromotionEventManagement />
                    </AdminTabContent>
                </TabStripTab>

                <TabStripTab title="Price Observations">
                    <AdminTabContent>
                        <PriceObservationManagement />
                    </AdminTabContent>
                </TabStripTab>

                <TabStripTab title="Customers">
                    <AdminTabContent>
                        <CustomerManagement />
                    </AdminTabContent>
                </TabStripTab>

                <TabStripTab title="Users">
                    <AdminTabContent>
                        <UserManagement />
                    </AdminTabContent>
                </TabStripTab>

                <TabStripTab title="Commercial Findings">
                    <AdminTabContent>
                        <CommercialFindingManagement />
                    </AdminTabContent>
                </TabStripTab>

                <TabStripTab title="Knowledge Base">
                    <AdminTabContent>
                        <KnowledgeInsightManagement />
                    </AdminTabContent>
                </TabStripTab>

                <TabStripTab title="Settings">
                    <AdminTabContent scrollable>
                        <AdminSettings />
                    </AdminTabContent>
                </TabStripTab>
            </TabStrip>
        </div>
    );
};

export default Admin;
